import React from 'react';
import AllQuestion from './AllQuestion';
import QuerySection from './QuerySection';
import { GroupedQuestion } from './IFAQAllQuestionPage';
import BreadCrumb from '../../components/Breadcrumbs';
import DefaultLayout from '../../layouts/DefaultLayout';
import Container from '../../components/ui/Container';
import Panel from '../../components/ui/Panel';

export const FAQAllQuestionPage: React.FC<GroupedQuestion> = ({
  categories,
}) => {
  const breadcrumbLinks = [
    { name: 'Home', linkTo: '/' },
    { name: 'Veelgestelde vragen', linkTo: `/home/faq` },
    { name: 'Alle vragen', linkTo: '/home/faqoverzicht' },
  ];

  return (
    <DefaultLayout breadcrumbs={<BreadCrumb links={breadcrumbLinks} />}>
      <Container state="defaultLayoutFirst">
        <Panel variant="collapsed" position="last">
          <Panel.Content>
            <AllQuestion categories={categories} />
          </Panel.Content>
          <Panel.Sidebar>
            <QuerySection />
          </Panel.Sidebar>
        </Panel>
      </Container>
    </DefaultLayout>
  );
};

FAQAllQuestionPage.displayName = "Page:FaqOverview";

export default FAQAllQuestionPage;